import { createGlobalState } from 'react-hooks-global-state';

const { setGlobalState, useGlobalState } = createGlobalState({ 
	user : undefined
});

export { setGlobalState, useGlobalState }